"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_js_1 = __importDefault(require("@hh.ru/analytics-js"));
/** На моб вебе в целевом варианте будет открываться всегда в бш (сурс постоянный - ), на десктопе как тул тип (сурс может быть разный) */
const headerGeoDefinitionButtonClick = ({ buttonName, ...analyticsParams }) => analytics_js_1.default.sendHHEventButtonClick(buttonName, { buttonName, ...analyticsParams });
exports.default = headerGeoDefinitionButtonClick;
